import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import { ImportModalComponent } from 'components/RootModal/modalRegistry';

export const BILL_SETUP_FLOW_DIALOG_TYPE = 'BILL_SETUP_FLOW';

ImportModalComponent(BILL_SETUP_FLOW_DIALOG_TYPE, () => import('./index'));

export const dispatchBillSetupFlowDialog = (): void => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: BILL_SETUP_FLOW_DIALOG_TYPE,
        props: ImmutableMap({}),
      }),
    ),
  );
};

export default dispatchBillSetupFlowDialog;
